import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=73900b4f&scoped=true&"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordRequest.vue?vue&type=style&index=0&id=73900b4f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73900b4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VTextField})
